import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ConfirmationDialog } from '../../../../../common/dialogs/ConfirmationDialog';
import { AlertCard, getAlertCardColors } from '../../../../../common/cards/alert-card/AlertCard';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { GET_ACHIEVEMENT_BACKFILL_COUNT } from './admin-console-achievements.gql';
import {
  GetAchievementBackfillCount,
  GetAchievementBackfillCountVariables,
} from './__generated__/GetAchievementBackfillCount';

interface Props {
  achievement?: { achievementId: string; name: string };
  onClose: () => void;
  onConfirm: () => void;
}

export const BackfillAchievementDialog = ({ achievement, onClose, onConfirm }: Props) => {
  const { data, loading } = useCampfireQuery<GetAchievementBackfillCount, GetAchievementBackfillCountVariables>(
    GET_ACHIEVEMENT_BACKFILL_COUNT,
    { options: { variables: { achievementId: achievement?.achievementId ?? '' }, skip: !achievement } }
  );
  const count = data?.vm.achievement?.backfillCount ?? 0;
  const infoColours = getAlertCardColors('info');

  const summary = loading
    ? 'Checking who already qualifies...'
    : count === 0
    ? 'Nobody else qualifies right now.'
    : `${count} volunteer${count === 1 ? '' : 's'} will receive at least one level.`;

  return (
    <ConfirmationDialog
      title='Backfill awards'
      body={
        <Box>
          <Typography gutterBottom>
            {`Award ${achievement?.name ??
              'this achievement'} to volunteers who already qualified before its levels went live.`}
          </Typography>
          <Box mt={2}>
            <AlertCard variant='info' title='No emails are sent'>
              <Typography style={{ fontSize: '14px', color: infoColours.darkTextColor }}>
                {`Backfilled awards appear on volunteer profiles quietly. ${summary}`}
              </Typography>
            </AlertCard>
          </Box>
        </Box>
      }
      open={Boolean(achievement)}
      closeActionText='Cancel'
      confirmActionText='Backfill'
      confirmActionColor='primary'
      disableConfirm={loading || count === 0}
      handleCloseClick={onClose}
      handleConfirmClick={onConfirm}
    />
  );
};
